<script lang="ts">
    export let value: number;
    export let title: string;
    export let isSelected: boolean;
    export let onChange: () => void;
    /** Konto bez can_write tylko oglada harmonogram - klikniecie nie moze nic zmieniac. */
    export let disabled: boolean = false;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="one-number-container"
    class:active={isSelected}
    class:write-blocked={disabled}
    on:click={() => {
        // to div, a nie button - samo pointer-events z CSS nie wystarczy jako blokada
        if (disabled) return;
        onChange();
    }}
>
    <div>
        {title}
    </div>
</div>

<style>
    .one-number-container {
        /*margin: 0.25rem;*/
        width: 20px;
        height: 18px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        cursor: pointer;
        background-color: #ffffff;
        color: var(--automapa-blue);
    }
    .active {
        background-color: var(--automapa-blue);
        color: white;
    }
    .one-number-container.write-blocked {
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
